import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, ClickAwayListener, Dialog, useMediaQuery } from '@material-ui/core'
import { handleRedirectInternal } from '@/custom/common/components'
import CustomDrawer from '@/custom/components/molecules/CustomDrawer'
import { Autocomplete } from '@/custom/components/molecules/Header/autocomplete'
import FilterPanel from '@/custom/common/FilterPanel'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/custom/components/organisms/Dialog'
import { getAlgoliaResults } from '@algolia/autocomplete-js'
import SearchComp from '@/views/Search/SearchComp'
import SavedSearch from '@/views/Search/SavedSearch'
import '../../views/Home/Home.css'
import ListingDropdown from '../components/atoms/ListingDropdown'
import AuthContext from '@/product/context/auth/authContext'
import SignContext from '../context/signContext'
import Login from '@/views/Login/login'
import Registration from '@/views/Registration'
import Popup from '../components/organisms/Popup'
import { mapData, dateFormatFunction, dateTimeFormatFunction } from '@/product/common/components'
const AllListings = ({ filterFilelds, searchClient, isHome, ...props }) => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const [openSearch, setOpenSearch] = useState(false)
    // const [searchText, setSearchText] = useState('')
    const searchText = props.searchText
    const setSearchText = props.setSearchText
    const { isAuthenticated } = authContext
    const { handleLoginPopup } = useContext(SignContext)
    const handletoggleSearch = () => {
        setOpenSearch((prev) => !prev)
    }
    const [localData, setLocalData] = useState('')
    const [dateProps, setDateProps] = useState(null)
    const [openPopup, setOpenPopup] = useState(false)
    useEffect(() => {
        setLocalData(props.searchText)
    }, [props.searchText])
    const isMobile = useMediaQuery('(max-width:1200px)')
    const isMiniMobile = useMediaQuery('(max-width:1024px)')
    const isSmallMobile = useMediaQuery('(max-width:600px)')

    const handleFilterRange = () => {
        setDateProps(true)
    }
    const dateRange = [
        {
            label: 'From Date ',
            placeholder: 'MM-DD-YYYY HH:MM',
            type: 'datetime',
            disablePast: true,
            filter: true,
            icon_only: true,
            class: isSmallMobile ? 'col-12' : 'col-6',
            upperLabel: true,
            name: 'date_added',
            formik: props.formikSearch,
        },
        {
            label: 'To Date ',
            placeholder: 'MM-DD-YYYY HH:MM',
            disablePast: true,
            filter: true,
            upperLabel: true,
            icon_only: true,
            type: 'datetime',
            class: isSmallMobile ? 'col-12' : 'col-6',
            name: 'date_closed',
            minDate: dateTimeFormatFunction(
                props.formikSearch.values?.filters?.date_added?.value || '',
            ),
            minDateMessage: `Date should not be before minimal date ${dateTimeFormatFunction(
                props.formikSearch.values?.filters?.date_added?.value || '',
            )}`,

            formik: props.formikSearch,
        },
    ]
    const clearFn = () => {
        let isValue = false
        if (props.formikSearch.values.filters?.date_added?.value) {
            props.formikSearch.setFieldValue(`filters.date_added.value`, '')
            props.formikSearch.values.filters.date_added.value = ''
            isValue = true
        }
        if (props.formikSearch.values?.filters?.date_closed?.value) {
            props.formikSearch.setFieldValue(`filters.date_closed.value`, '')
            props.formikSearch.values.filters.date_closed.value = ''
            isValue = true
        }
        if (isValue) {
            // INFINITE SCROLL - Commented out for pagination
            // props.formikSearch.values.infinite = false
            props.formikSearch.values.page = 1
            props.formikSearch.setFieldValue('page', 1)
            props.formikSearch.handleSubmit()
        }

        setOpenPopup(false)
    }
    return (
        <>
            <div className="search">
                <div className="">
                    <div className="mt-lg-3 mt-2 customContainer">
                        <div className="home-content-head mb-0 featuredHead listingHead">
                            All Listings
                        </div>
                    </div>
                    <CustomDialog
                        diableBac
                        className="dateRangeDialog"
                        open={openPopup}
                        function={clearFn}
                        title={'Search date range'}
                    >
                        <div>{Object.values(mapData(dateRange))}</div>{' '}
                        <div className="filterBtnGrp">
                            <PrimaryButton
                                className=""
                                btnSize="small"
                                id="checkout_pay_make"
                                onClick={clearFn}
                                // disabled={props.isCouponLoading}
                                label={'Clear'}
                            />
                            <PrimaryButton
                                btnSize="small"
                                id="checkout_pay_make"
                                onClick={() => {
                                    if (
                                        props.formikSearch.values.filters?.date_added?.value ||
                                        props.formikSearch.values?.filters?.date_closed?.value
                                    ) {
                                        // INFINITE SCROLL - Commented out for pagination
                                        // props.formikSearch.values.infinite = false
                                        props.formikSearch.values.page = 1
                                        props.formikSearch.setFieldValue('page', 1)
                                        props.formikSearch.handleSubmit()
                                    }

                                    setOpenPopup(false)
                                }}
                                // disabled={props.isCouponLoading}
                                label={'Apply'}
                            />
                        </div>
                    </CustomDialog>
                    <div className="current-sales-section align-items-center justify-content-center justify-content-md-between search-filters-wrapper mt-4 customContainer flex-wrap position-relative">
                        {isMiniMobile ? null : (
                            <div className="d-flex filtKing align-items-center">
                                {filterFilelds?.data?.map((data, index) => (
                                    <ListingDropdown
                                        key={index}
                                        data={data}
                                        label={data?.label}
                                        options={data?.options}
                                        handleFormikChange={data?.onChange}
                                        formik={filterFilelds?.formik}
                                        setOpenPopup={setOpenPopup}
                                        // hanldeDateFIlter={dateProps}
                                    />
                                ))}
                                <Button
                                    id="filters_clear"
                                    onClick={() => {
                                        props.clearSearchFilter()
                                        if (props.clearingLocationFilter) {
                                            props.clearingLocationFilter()
                                        }
                                    }}
                                    className="filterClear ml-auto col-6"
                                >
                                    Clear all
                                </Button>
                            </div>
                        )}
                        {/* <div
                            className=" mb-0 d-flex align-center
                                "
                            style={{ width: '100%', maxWidth: '495px' }}
                        >
                        </div> */}
                        <div className="form-inline my-2 my-lg-0 headerSearchForm sbc">
                            {/* <ClickAwayListener onClickAway={handletoggleSearch}>
                                <Autocomplete
                                    value={props.searchText}
                                    open={openSearch}
                                    onOpen={handletoggleSearch}
                                    onClose={handletoggleSearch}
                                    openOnFocus={true}
                                    onSubmit={(stateData) => {
                                        stateData.setIsOpen(false)
                                        props.handleSearchAutocompleteTextChange(stateData, false)
                                    }}
                                    getSources={({ query }) => [
                                        {
                                            sourceId: 'products',
                                            onSelect({ setIsOpen, setQuery, event, item }) {
                                                window.open(
                                                    `/product-view/${item?.objectID}`,
                                                    '_blank',
                                                )
                                            },
                                            getItems() {
                                                return getAlgoliaResults({
                                                    searchClient,
                                                    queries: [
                                                        {
                                                            indexName:
                                                                process.env.REACT_APP_ALGOLIA_INDEX,
                                                            query,
                                                        },
                                                    ],
                                                })
                                            },

                                            templates: {
                                                header() {
                                                    return 'Suggestions'
                                                },
                                                item({ item, components }) {
                                                    return (
                                                        <>
                                                            {item?.objectID ? (
                                                                <div className="aa-ItemTitle">
                                                                    <components.Highlight
                                                                        hit={item}
                                                                        attribute="title"
                                                                    />
                                                                </div>
                                                            ) : null}
                                                        </>
                                                    )
                                                },
                                            },
                                        },
                                    ]}
                                />
                            </ClickAwayListener> */}
                            <input
                                type="text"
                                onChange={(e) => {
                                    setLocalData(e.target.value)
                                    setSearchText(e.target.value)
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setSearchText(searchText.trim())
                                        props.handleFormikChange(`searchbar`, searchText.trim(), 1)
                                    }
                                }}
                                value={localData || ''}
                            />
                            <button
                                onClick={() => {
                                    setSearchText(searchText.trim())
                                    props.handleFormikChange(`searchbar`, searchText.trim(), 1)
                                }}
                                className="search-icon"
                            >
                                <img src="/assets/svg/search.svg" />
                            </button>
                            <button
                                onClick={() => {
                                    setSearchText('')
                                    props.handleFormikChange(`searchbar`, '', 1)
                                }}
                                className="clear-icon"
                            >
                                <img src="/assets/svg/closeIcon1.svg" />
                            </button>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3">
                            <ul className="d-flex align-items-center salesPart mr-3">
                                <li className="salesItem">
                                    <Button
                                        onClick={
                                            isAuthenticated
                                                ? () =>
                                                      handleRedirectInternal(
                                                          history,
                                                          'favorites/watchlist',
                                                      )
                                                : handleLoginPopup
                                        }
                                    >
                                        {isMobile ? (
                                            <span className="material-icons-outlined">
                                                favorite
                                            </span>
                                        ) : (
                                            <span>Favorites</span>
                                        )}
                                        {props.count?.watchlistCount > 0 && (
                                            <span className="count">
                                                {props.count?.watchlistCount}
                                            </span>
                                        )}
                                    </Button>
                                </li>
                                <li className="salesItem">
                                    <Button
                                        onClick={
                                            isAuthenticated
                                                ? () =>
                                                      handleRedirectInternal(history, 'offers/all')
                                                : handleLoginPopup
                                        }
                                    >
                                        {isMobile ? (
                                            <span className="material-icons-outlined">
                                                local_offer
                                            </span>
                                        ) : (
                                            <span>Your offers</span>
                                        )}
                                        {props.count?.bidsCount > 0 && (
                                            <span className="count">{props.count?.bidsCount}</span>
                                        )}
                                    </Button>
                                </li>
                                <li className="salesItem">
                                    <Button
                                        onClick={
                                            isAuthenticated
                                                ? () => handleRedirectInternal(history, 'cart')
                                                : handleLoginPopup
                                        }
                                    >
                                        {isMobile ? (
                                            <>
                                                {/* <span className="material-icons-outlined">
                                                    shopping_bag
                                                </span> */}
                                                <img
                                                    src="/assets/images/shop-blk-ico.png"
                                                    alt="shop-blk-ico"
                                                />
                                            </>
                                        ) : (
                                            <span>View your Cart</span>
                                        )}

                                        {props.count?.buynowCount > 0 && (
                                            <span className="count">
                                                {props.count.buynowCount || 0}
                                            </span>
                                        )}
                                    </Button>
                                </li>
                                {isMobile && (
                                    <li className="salesItem">
                                        <Button onClick={() => setOpenPopup(true)}>
                                            <>
                                                <span className="material-icons-outlined">
                                                    calendar_month
                                                </span>
                                            </>
                                        </Button>
                                    </li>
                                )}
                            </ul>
                            <div className="al-filter-button">
                                <button
                                    onClick={props.toggleDrawer}
                                    type="button"
                                    className="af-btn"
                                >
                                    {isMobile ? (
                                        <span className="material-icons-outlined">filter_list</span>
                                    ) : (
                                        <>
                                            <span className="filtero">Filters</span>
                                            <span className="material-icons">menu</span>
                                        </>
                                    )}
                                    {/* <img src="/assets/images/FadersHorizontal.png" alt="" /> */}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <SavedSearch
                            formikSearch={props.formikSearch}
                            handleFormikChange={props.handleFormikChange}
                            isvisible={true}
                            updated={props.updated}
                            from={props.from}
                        />
                        <SearchComp
                            formikSearch={props.formikSearch}
                            clearSearchFilter={props.clearSearchFilter}
                            auctionView={props.auctionView}
                            pagination={true}
                            isHome={isHome}
                            from={props.from}
                            initialLoad={props.initialLoad}
                            setInitialLoad={props.setInitialLoad}
                            isProductLoading={props?.isProductLoading}
                            setIsProductLoading={props.setIsProductLoading}
                        />
                    </div>
                </div>
                <CustomDrawer
                    toggleDrawer={props.toggleDrawer}
                    anchor="right"
                    open={props.drawerOpen}
                    className="custom-drawer register-drawer search-filter-drawer"
                >
                    <FilterPanel
                        formik={props.formikSearch}
                        clearSearch={props.clearSearchFilter}
                        from={1}
                        show={props.show}
                        arrayValue={props.arrayValue}
                        update={props.update}
                        handleFormikChange={props.handleFormikChange}
                        filtersLoaded={props.filtersLoaded}
                        condition={props.condition}
                        locationData={props.locationData}
                        category={props.category}
                    />
                </CustomDrawer>
            </div>
        </>
    )
}

export default AllListings
